<template>
  <b-card title="Роли">
    <div
      v-if="loading"
      class="text-center text-primary my-2"
    >
      <b-spinner class="align-middle mr-50" />
      <strong>Загрузка...</strong>
    </div>

    <div
      v-for="role in roles"
      :key="role.id"
      class="mb-2"
    >
      <div class="d-flex align-items-center mb-50">
        <h5 class="mb-0 mr-1">{{ role.name }}</h5>
        <b-badge
          v-if="!role.editable"
          variant="light-primary"
        >
          полный доступ
        </b-badge>
        <b-button
          v-if="role.editable && $can('manage', 'users')"
          size="sm"
          variant="primary"
          class="ml-auto"
          :disabled="saving"
          @click="saveRole(role)"
        >
          Сохранить
        </b-button>
      </div>

      <table class="table table-sm">
        <thead>
          <tr>
            <th>Раздел</th>
            <th>Просмотр</th>
            <th>Редактирование</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="section in sections" :key="section">
            <td>{{ section }}</td>
            <td>
              <b-form-checkbox
                :checked="role.permissions.includes(`${section}.view`)"
                :disabled="!role.editable || !$can('manage', 'users')"
                @change="togglePermission(role, `${section}.view`)"
              />
            </td>
            <td>
              <b-form-checkbox
                :checked="role.permissions.includes(`${section}.manage`)"
                :disabled="!role.editable || !$can('manage', 'users')"
                @change="togglePermission(role, `${section}.manage`)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BBadge, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard, BButton, BBadge, BFormCheckbox, BSpinner,
  },
  data() {
    return {
      loading: false,
      saving: false,
      roles: [],
      sections: [],
    }
  },
  created() {
    // Лоадер снимаем только когда пришли оба справочника — без sections таблица прав пустая.
    this.loading = true
    Promise.all([
      this.$http.get('/roles').then(response => { this.roles = response.data }),
      this.$http.get('/permissions').then(response => { this.sections = response.data.sections }),
    ]).finally(() => { this.loading = false })
  },
  methods: {
    togglePermission(role, permissionName) {
      const index = role.permissions.indexOf(permissionName)
      if (index === -1) {
        role.permissions.push(permissionName)
      } else {
        role.permissions.splice(index, 1)
      }
    },
    saveRole(role) {
      this.saving = true
      this.$http.put(`/roles/${role.id}`, { permissions: role.permissions })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: { title: `Роль ${role.name} сохранена`, icon: 'CheckIcon', variant: 'success' },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Ошибка сохранения', icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
        .finally(() => { this.saving = false })
    },
  },
}
</script>
